import { QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

const QuizAttemptUtils = {
  // TODO getLastByQuestion would be a better name
  getLast(quizAttempts, questionId) {
    return quizAttempts
      .sortBy((quizAttempt) => quizAttempt.get('attempted_ts'))
      .filter((quizAttempt) => quizAttempt.get('question') === questionId)
      .last();
  },

  isMultiChoice(quizAttempt) {
    return (
      quizAttempt &&
      [
        QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE,
        QUESTION_TYPES.MULTI_ANSWER_MULTI_CHOICE,
      ].includes(quizAttempt.get('answer_type'))
    );
  },

  isWorthFullMarksOrZero(quizAttempt) {
    return (
      quizAttempt &&
      (this.isMultiChoice(quizAttempt) ||
        quizAttempt.get('answer_type') === QUESTION_TYPES.NO_RESPONSE)
    );
  },

  hasFullMarks(quizAttempt, question) {
    // TODO only for self/prac mark questions?
    return (
      parseInt(quizAttempt.get('answer'), 10) ===
      question.get('indicated_maximum_marks')
    );
  },

  isCorrect(quizAttempt, question) {
    return (
      quizAttempt &&
      (quizAttempt.get('is_correct') ||
        this.hasFullMarks(quizAttempt, question))
    );
  },
};

export default QuizAttemptUtils;
